module.exports = __webpack_public_path__ + "img/e_3_10_g.09ede7b1.png";